import { styled, Box } from '@mui/material';

export const GoldBox = styled(Box)({
    background: `radial-gradient(ellipse farthest-corner at right bottom, #FFD700 0%, #FFC107 8%, #FFB300 30%, #FFA000 40%, transparent 80%),
                 radial-gradient(ellipse farthest-corner at left top, #FFF8E1 0%, #FFE082 8%, #FFD54F 25%, #FFA000 62.5%, #FFA000 100%)`
})
//    background: radial-gradient(ellipse farthest-corner at right bottom, #FEDB37 0%, #FDB931 8%, #9f7928 30%, #8A6E2F 40%, transparent 80%),
// radial-gradient(ellipse farthest-corner at left top, #FFFFFF 0%, #FFFFAC 8%, #D1B464 25%, #5d4a1f 62.5%, #5d4a1f 100%)

export default GoldBox;